export default "__VITE_ASSET__wQ2MoIW1__"